// Trust levels for sellers
// Determines what capabilities a seller has on the platform
export const TRUST_LEVEL = {
  UNAUTHORIZED: 0, // No seller account
  AUTHORIZED: 1, // Basic seller account
  VERIFIED: 2, // Stripe Connect complete - can accept payments
} as const;

export type TrustLevel = (typeof TRUST_LEVEL)[keyof typeof TRUST_LEVEL];

// Helper to check if seller can accept payments
export const canAcceptPayments = (trustLevel: number | undefined | null): boolean => {
  return trustLevel === TRUST_LEVEL.VERIFIED;
};
